import firebase from 'firebase/app'
import 'firebase/storage'
import 'firebase/analytics'
import Helpers from '../helpers/shared.helper';
import Settings from './settings.service';
import Storage from "./storage.service";

var FirebaseAnalytics = {};

FirebaseAnalytics.onload = () => {
    let uid = Storage.get("uid", true);
    const fireObj = {
        device_id: Storage.get("device_id", true),
        session: Storage.get("session", true),
        platform: "web",
        lang: Helpers.getCookie("lang"),
        environment: Settings.environment,
        uid: uid,
        build_no: 1,
        product_category: "regular"
    }
    firebase.analytics().setUserProperties(fireObj);
    if (uid) {
        firebase.analytics().setUserProperties({ uid: uid });
    }
}

FirebaseAnalytics.init = () => {
    if (Settings?.firebase_enabled && !firebase.apps.length) {
        firebase.initializeApp(Settings?.firebase_analytics_configs);
        FirebaseAnalytics.onload();
    }
}

// Set User if Any Property Changes
FirebaseAnalytics.updateUser = (eventParams = {}) => {
    if (Settings?.firebase_enabled) {
        firebase.analytics().setUserProperties(eventParams);
    }
}

/**
 * Language Updated
 */
FirebaseAnalytics.preferred_lang_updated = (lang) => {
    if (Settings?.firebase_enabled) {
        firebase.analytics().setUserProperties({ lang: lang, });
    }
}

/**
 * Log Event Fot the Analytics with event and params
 * @param eventName
 * @param eventParams
 * @param options
 */
FirebaseAnalytics.logEvent = (eventName, eventParams = {}, options = false) => {
    if (Settings?.firebase_enabled) {
        firebase.analytics().logEvent(eventName, eventParams, options);
    }
};

FirebaseAnalytics.number_selected = (param) => {
    FirebaseAnalytics.logEvent('number_selected', param);
}

FirebaseAnalytics.vanityDetail = (param) => {
    console.log("vanityDetail", param);
    FirebaseAnalytics.logEvent('vanity', param);
}

FirebaseAnalytics.search_executed = (param) => {
    FirebaseAnalytics.logEvent('search_executed', param);
}

FirebaseAnalytics.plan_selected = (param) => {
    FirebaseAnalytics.logEvent('plan_selected', param);
}
FirebaseAnalytics.additional_offer_added = (param) => {
    FirebaseAnalytics.logEvent('additional_offer_added', param);
}

FirebaseAnalytics.offer_removed = () => {
    FirebaseAnalytics.logEvent('offer_removed');
}
FirebaseAnalytics.offer_applied = (param) => {
    FirebaseAnalytics.logEvent('offer_removed', param);
}

FirebaseAnalytics.create_account_check = (param) => {
    FirebaseAnalytics.logEvent('create_account_check', param);
}

FirebaseAnalytics.create_account_pass = (param) => {
    FirebaseAnalytics.logEvent('create_account_pass', param);
}

FirebaseAnalytics.create_account_success = (param) => {
    FirebaseAnalytics.logEvent('create_account_success', param);
}

FirebaseAnalytics.authentication_success = () => {
    FirebaseAnalytics.logEvent('authentication_success');
}

FirebaseAnalytics.sim_scanned = (param) => {
    FirebaseAnalytics.logEvent('sim_scanned', param);
}

FirebaseAnalytics.begin_checkout = (param) => {
    FirebaseAnalytics.logEvent('begin_checkout', param);
}

FirebaseAnalytics.ecommerce_purchase = (param) => {
    console.log("ecommerce_purchase", param)
    FirebaseAnalytics.logEvent('ecommerce_purchase', param);
}

FirebaseAnalytics.delivery_request = () => {
    FirebaseAnalytics.logEvent('delivery_request');
}

FirebaseAnalytics.delivery_qr_viewed = () => {
    FirebaseAnalytics.logEvent('delivery_qr_viewed');
}

FirebaseAnalytics.sim_activated = (param) => {
    FirebaseAnalytics.logEvent('sim_activated', param);
}

FirebaseAnalytics.error_ocurred = (param) => {
    if (param?.screen_name === "confirmation") {
        FirebaseAnalytics.logEvent('payment_error', param);
    } else {
        FirebaseAnalytics.logEvent('error_ocurred', param);
    }
}

FirebaseAnalytics.button_clicked = (btnText) => {
    let screen = Storage.get('Page_name');
    let btnDefault = {
        item_id: screen && btnText ? `${screen}_${btnText}_btn` : "",
        screen_name: screen,
        item_text: btnText ? btnText : ""
    }
    FirebaseAnalytics.logEvent('button_clicked', btnDefault);
}

FirebaseAnalytics.delivery_delivered = (param) => {
    FirebaseAnalytics.logEvent('delivery_delivered', param);
}


export default FirebaseAnalytics;